// extracted by mini-css-extract-plugin
export default {"wrapper":"BillsPaymentDetails_wrapper__hMrht","detail":"BillsPaymentDetails_detail__kot3s"};